module.exports = __webpack_public_path__ + "static/img/business_white.f244f6c0.png";